import { AlertTriangle, RotateCcw } from 'lucide-react';
import { Button } from './Button';

type Props = {
  message?: string;
  onRetry?: () => void;
};

export function ErrorState({ message = 'Something went wrong.', onRetry }: Props) {
  return (
    <div className="flex flex-col items-start gap-4 border-l-2 border-danger pl-5 py-1">
      <div className="flex items-center gap-3">
        <AlertTriangle size={16} className="text-danger flex-shrink-0" />
        <p className="text-sm font-black text-text uppercase tracking-wide">Error</p>
      </div>
      <p className="text-sm text-muted">{message}</p>
      {onRetry && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onRetry}
          className="border border-line py-2 hover:!bg-transparent hover:!border-danger hover:!text-danger"
        >
          <RotateCcw size={12} />
          Try again
        </Button>
      )}
    </div>
  );
}
